import React, { useEffect } from 'preact/compat';
import { ErrorMessage, useFormikContext } from 'formik';

export default function FormError({ name }: ErrorProps) {
    return (
        <ErrorMessage name={name}>
            {(message: string) => (
                <div className='error  form__error  js-form-error'>
                    {message}
                </div>
            )}
        </ErrorMessage>
    );
}

type ErrorProps = {
    name: string,
};

export function ScrollToFirstError() {
    const { submitCount, isValid } = useFormikContext();

    useEffect(() => {
        if (isValid) {
            return;
        }

        const error = document.querySelector('.js-form-error');

        if (error === null) {
            return;
        }

        (error.parentElement ?? error).scrollIntoView();
    }, [submitCount]);

    return null;
}
